import React, {useEffect, useState} from "react";
import {useJson} from "../utils/json";
import {createRoot} from "react-dom/client";
import {getAndStripAttribute} from "../utils/dom-container-util";
import {flushSync} from "react-dom";

const ProgressTrackerContainer = (props) => {
  const {parseJson} = useJson();
  const initialModel = {
    'remaining-amount': '',
    'upsell-highlight': '',
    'upsell-message': '',
    'milestones': [],
    'max-milestone': 100,
    'applicable-amount': 0,
    'shipping-qualified': '',
    'shipping-highlight': '',
    'tooltip-label': '',
    'tooltip-text': ''
  };
  const model = props.model === "" || props.model === "{}"
    ? initialModel
    : parseJson(props.model);
  let [payloadData, setPayloadData] = useState(model);
  const remainingAmount = payloadData["remaining-amount"];
  const upsellHighlight = payloadData["upsell-highlight"];

  useEffect(() => {
    window.handleUpdateProgressTrackerData = handleUpdateProgressTrackerData;

    if($('.progress-tracker-container-clone-alternate').length) {
      updateAlternateTrackerClones();
    }
    else {
      updateTrackerClones();
    }
  }, []);

  function handleUpdateProgressTrackerData(payloadJson, useAlternate = false) {
    const {parseJson} = useJson();
    const model = parseJson(payloadJson);
    $('.progress-tracker-container-clone').find('.applicable-amount').css('width', model["applicable-amount"] + "%");
    flushSync(() => {
      setPayloadData({
                       ...payloadData,
                       "upsell-message": model["upsell-message"] ?? initialModel["upsell-message"],
                       "upsell-highlight": model["upsell-highlight"] ?? initialModel["upsell-highlight"],
                       "applicable-amount": model["applicable-amount"] ?? initialModel["applicable-amount"],
                       "remaining-amount": model["remaining-amount"] ?? initialModel["remaining-amount"],
                       "milestones": model.milestones ?? initialModel.milestones,
                       "max-milestone": model["max-milestone"] ?? initialModel["max-milestone"],
                       "shipping-qualified": model["shipping-qualified"] ?? initialModel["shipping-qualified"],
                       "shipping-highlight": model["shipping-highlight"] ?? initialModel["shipping-highlight"],
                       "tooltip-label": model["tooltip-label"] ?? initialModel["tooltip-label"],
                       "tooltip-text": model["tooltip-text"] ?? initialModel["tooltip-text"]
                     });
    });


    if(useAlternate) {
      updateAlternateTrackerClones();
    }
    else {
      updateTrackerClones();
    }
  }

  function updateTrackerClones() {
    $('.progress-tracker-container-clone').html($('#progress-tracker-container').find('.tracker-content').clone());
  }

  function updateAlternateTrackerClones() {
    $('.progress-tracker-container-clone-alternate').html($('#progress-tracker-container').find('.tracker-content').clone());
  }

  const compiledMessage = payloadData["upsell-message"].replace('{{remaining-amount}}',
                                                                `<span class='tracker-remaining-amount'>${remainingAmount}</span>`).replace(
    '{{upsell-highlight}}', `<span class='tracker-upsell-highlight'>${upsellHighlight}</span>`);
  const shippingQualifiedMessage = payloadData["shipping-qualified"];
  const shippingHighlight = payloadData["shipping-highlight"];
  const maxMilestone = payloadData["max-milestone"];
  const trackerPercent = Math.min((payloadData["applicable-amount"] / maxMilestone) * 100, 100);
  const tooltipLabel = payloadData["tooltip-label"];
  const tooltipText = payloadData["tooltip-text"];
  return (
    <div className={`tracker-content ${payloadData.milestones.length === 0 ? 'empty' : ''}`}>
      {shippingQualifiedMessage !== '' ? <div>{shippingQualifiedMessage} <span className='tracker-upsell-highlight'>{shippingHighlight}</span></div> : null}
      <div className={'tracker-title-container'}>
        {compiledMessage !== '' ? <div className={'milestone-tracker-title'} aria-live={'polite'} dangerouslySetInnerHTML={{__html: compiledMessage}}/> : null}
        <div className={'tracker-tooltip'}><span data-toggle="tooltip" data-container="body" title={tooltipText} aria-label={tooltipText}>{tooltipLabel}</span>
        </div>
      </div>
      {payloadData.milestones && payloadData.milestones.length > 0 ? <div className={'milestone-tracker'}>
        {payloadData.milestones.map((milestone, i) => {
          let leftOffset = (milestone.milestoneAmount === 0) ? '20px' : ((milestone.milestoneAmount / maxMilestone) * 100) + '%';
          let milestoneClass = milestone.achieved ? 'milestone surpassed' : 'milestone';
          return <span key={i} className={milestoneClass} style={{left: `${leftOffset}`}}></span>;
        })}
        <span className={'applicable-amount'} style={{width: `${trackerPercent}%`, transition: 'width 1s'}}/>
      </div> : null}

      {payloadData.milestones && payloadData.milestones.length > 0 ? <div className={'milestone-texts'}>
        {payloadData.milestones.map((milestone, i) => {
          let milestoneText = milestone.milestoneText.replace('{{milestone-amount}}', milestone.milestoneAmount);
          let milestoneTextClass = milestone.achieved ? 'milestone-text surpassed' : 'milestone-text';
          return <div key={i} className={milestoneTextClass}>{milestoneText}</div>;
        })}
      </div> : null}
    </div>
  );
};

const domContainer = document.querySelector('#progress-tracker-container');
if (domContainer) {
  const model = getAndStripAttribute("data-model", domContainer);
  const root = createRoot(domContainer);
  root.render(<ProgressTrackerContainer model={model}/>);
}

